export default "__VITE_ASSET__BQlJ_sZo__"